import React from 'react'
import { Header, Button, Heading, Text } from 'base-ui'
import Highlighter from './Highlight'
import { PageWrapper } from './PageWrapper'
import { Header as HeaderExample } from '../examples/Header'

const Headers = () => {
  return (
    <PageWrapper title="Headers">
      <Text size="md">
      Header is a secong-level navigation item used in independent apps and workflows. It should contain branding, basic navigation elements and actions.
      </Text>
        <div className="bg-gray-50 p-4 my-4 rounded-md">
            <Header title="Header Title">
                <Button color='primary' label="Action"/>
            </Header>
        </div>
        <div className="bg-gray-50 p-4 my-4 rounded-md">
            <Header reverseColor={true} >
                <Button color="primary-on-dark" label="Action"/>
            </Header>
        </div>
        <Heading size="h3">Sizes</Heading>
        <div className="bg-gray-50 p-4 my-4 rounded-md">
            <div>
                <Text size="md">Small </Text>
                <Header size="sm" />
            </div>
            <div>
                <Text size="md">Medium </Text>
                <Header size="md" />
            </div>
            <div>
                <Text size="md">Large</Text>
                <Header size="lg" />
            </div>
        </div>
        <Heading size="h3">Usage</Heading>
        <div className="py-4">
            <Highlighter code={HeaderExample} language='jsx' />
        </div>
    </PageWrapper>
  )
}

export default Headers
